import {useEffect} from 'react'
import ReactTooltip, {TooltipProps} from 'react-tooltip'

import './Tooltip.scss'

export default function Tooltip(props: TooltipProps) {
  useEffect(() => {
    ReactTooltip.rebuild()
  })

  return <ReactTooltip className="Tooltip" place="bottom" {...props} />
}
